var audio_rtlignore_default = {
  "fontElementMap": "myFfN",
  "container": "kPHKX",
  "customPlayer": "_9uyTV",
  "slim": "QDZQM",
  "playPauseButton": "vZRFS",
  "coverImage": "nOEkJ",
  "trackDetailsContainer": "BOsA3",
  "controlsContainer": "PEyP-",
  "controlsGroup": "_0pZ7Y",
  "sliderContainer": "FmRxV",
  "audioDuration": "RpKZD",
  "isLoading": "-n7zO",
  "audioDetails": "JtY0C",
  "authorName": "Kt0aY",
  "title": "OWvfk",
  "dropdownMenuWrapper": "UfPeE",
  "dropdownSelectedButton": "vKmJo",
  "dropdownContent": "BDMMk",
  "dropdownContentWithIcon": "Aumg8",
  "audioLoader": "Psjks"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
